module.exports = __webpack_public_path__ + "static/media/slide-image-5-large-min.ace4cbb5.jpg";